<template>
  <main class="sa-content">
    <template v-if="loader">
      <img
        src="../../../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader"
      />
    </template>
    <template v-else>
      <div class="sa-card-large">
        <div class="sa-mob-header">
          <h5 class="sa-card-tit">Treatment Referral</h5>
          <!-- <button class="sa-btn-back" @click="$router.push('/appointments/doctor-details/add-diagnosis/'+$route.params.appid)">
        <i class="icon-arrow-left"></i>
        </button> -->
        </div>
        <treatment-refer
          ref="treatRef"
          :viewDoctor="viewDoctor"
          :back="back"
          @backEvent="back = $event"
        />
      </div>
      <div
        class="sa-dialog sa-referdoctor"
        v-if="viewDoctor && doctorInfo"
        v-on:close-pop="closePop"
      >
        <div class="sa-dialog-body sa-device">
          <i
            class="icon-cancel sa-close sa-btn sa-close sa-close-line"
            @click="viewDoctor = false"
          ></i>
          <div class="sa-row">
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg1">
              <figure class="sa-avt-img">
                <img
                  alt="Doctor"
                  :src="
                    doctorInfo.img
                      ? doctorInfo.img
                      : 'https://img.litedev.com/mis/44f6c6650fa36dae2911fde3756117a8.jpg'
                  "
                  class="sa-img-cover sa-prof-img"
                />
              </figure>
            </div>
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg5">
              <h6>{{ doctorInfo.title_nm }} {{ doctorInfo.name }}</h6>
              <small>{{ doctorInfo.class_nm }}</small>
              <span v-if="doctorInfo.known_lang" class="sa-doc-text-left"
                >Language Spoken :
                <span class="sa-black-text">{{
                  Array.prototype.map
                    .call(doctorInfo.known_lang, function (item) {
                      return item;
                    })
                    .join(",")
                }}</span></span
              >
            </div>
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg6">
              <span class="sa-doc-text"
                >{{ doctorInfo.dept_name }}:<span class="sa-black-text">{{
                  doctorInfo.sub_speclty_nm
                }}</span></span
              >
              <span class="sa-doc-text"
                >Experience :
                <span v-if="doctorInfo.exp" class="sa-black-text">
                  {{ doctorInfo.exp.val }} {{ doctorInfo.exp.dur_typ }}</span
                ></span
              >
            </div>
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg12">
              <hr />
            </div>
            <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg12">
              <h6 v-if="doctorInfo && doctorInfo.bio" class="sa-mb10">
                About Doctor
              </h6>
              <span class="sa-doctor-txt">
                {{ doctorInfo.bio }}
              </span>
              <h5
                v-if="
                  doctorInfo &&
                  doctorInfo.special_in &&
                  doctorInfo.special_in.length > 0
                "
                class="sa-mt20"
              >
                Specialized in
              </h5>
              <ul class="sa-li-circle">
                <li v-for="(sp, ix) in doctorInfo.special_in" :key="ix">
                  {{ sp }}
                </li>
              </ul>
              <div class="sa-sa-form-group sa-mt40 sa-text-right">
                <button
                  @click="selectDoctor()"
                  class="sa-btn-primary sa-btn-large sa-btn-block-xs"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </main>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
import TreatmentReferVue from "../../../../components/appointments/diagnosis/treatment-referral/TreatmentRefer.vue";
export default {
  components: {
    "treatment-refer": TreatmentReferVue,
  },
  data() {
    return {
      viewDoctor: false,
      loader: false,
      back: false,
      doctorInfo: null,
    };
  },
  created() {
    // this.getReferralData()
  },
  methods: {
    selectDoctor: function () {
      this.viewDoctor = false;
      this.$refs["treatRef"].$refs["doctorRef"].selectDoctorFlag = false;
    },
    closePop: function () {
      this.viewDoctor = false;
    },
    getReferralData: function () {
      let _self = this;
      _self.loader = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/getTreatmentReferal`,
          body: {
            apnt_id: _self.$route.params.appid,
          },
        })
        .then((response) => {
          _self.loader = false;
        });
    },
  },
};
</script>
